import { render, staticRenderFns } from "./TeamsDatatable.vue?vue&type=template&id=20e39c1a&"
import script from "./TeamsDatatable.vue?vue&type=script&lang=js&"
export * from "./TeamsDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports